const getSelectedSlot = (daysArray, timeSlotArrays) => {
    let selectedSlot = {}
    for (let i = 0; i < daysArray.length; i++) {
        if (daysArray[i]?.is_selected) {
            selectedSlot = {
                title: daysArray[i]?.slot_header_data?.heading,
                nudgeText: daysArray[i]?.slot_header_data?.description,
                dayEpochSlot: daysArray[i]?.epoch_slot,
                isDayAvailable: daysArray[i]?.available,
                dayIndex: daysArray[i]?.day_index,
                date: daysArray[i]?.date,
                day: daysArray[i]?.title,
                slotsCount: daysArray[i]?.slots_count,
                mixPanelData: timeSlotArrays?.[daysArray[i]?.epoch_slot]?.analytics_data_mixpanel,
            }
            break
        }
    }
    return selectedSlot
}

const getSelectedTimeSlot = (timeSlotArrays, daysArray) => {
    let selectedSlotData = { slotId: null, isAvailable: false, epochSlot: null, slotIndex: 1 }
    const timeSlotData = timeSlotArrays[getSelectedSlot(daysArray)?.dayEpochSlot]?.slot_data
    for (let i = 0; i < timeSlotData?.length; i++) {
        if (timeSlotData[i]?.is_selected) {
            selectedSlotData = {
                slotId: timeSlotData[i]?.slot_id,
                isSlotAvailable: timeSlotData[i]?.available,
                timeEpochSlot: timeSlotData[i]?.epoch_slot,
                slotIndex: timeSlotData[i]?.slot_index,
                label: timeSlotData[i]?.label,
            }
            break
        }
    }
    return selectedSlotData
}

const getGASlot = (slotData) => {
    const slotGAData = slotData?.map((slot) => ({
        available: slot?.available,
        charge: slot?.sub_text ? slot?.sub_text : "0",
        epochslot: slot?.epoch_slot,
        slot: slot?.label,
        slot_id: slot?.slot_id,
    }))

    return slotGAData
}

const getGAData = (daysData, slotData, meta) => {
    const daysSlotMapping = []
    for (let i = 0; i < daysData.length; i++) {
        const daySlotMapping = {
            day: daysData[i]?.title,
            date: daysData[i]?.date,
            count_of_available_slots: daysData[i]?.sub_text,
            slots: getGASlot(slotData[daysData[i]?.epoch_slot]?.slot_data),
        }
        daysSlotMapping.push(daySlotMapping)
    }
    const gaData = {
        pincode: meta?.pincode,
        covid_flag: meta?.covid_flag,
        test_type: meta?.test_type,
        time_slot_mapping: daysSlotMapping,
    }
    return gaData
}

const getSelectedDaySlotGA = (dayData, slotData) => {
    let selectedDay = {}
    let selectedSlotGA = {}
    let selectedDaySlotGa = {}
    for (let day of dayData) {
        if (day.is_selected) {
            selectedDay = { ...day }
        }
    }
    const selectedSlot = slotData[selectedDay?.epoch_slot]?.slot_data
    for (let slot of selectedSlot) {
        if (slot?.is_selected) {
            selectedSlotGA = {
                charge: slot?.sub_text ? slot?.sub_text : "0",
                epochslot: slot?.epoch_slot,
                slot: slot?.label,
                slot_id: slot?.slot_id,
                slot_index: slot?.slot_index,
            }
        }
    }
    selectedDaySlotGa = {
        ...selectedSlotGA,
        day: selectedDay?.title,
        date: selectedDay?.date,
        day_index: selectedDay?.day_index,
        available: selectedDay?.available,
    }
    return selectedDaySlotGa
}

export const parseSlotWidget = (data, meta) => {
    let widgetsData = []
    data?.widgets?.forEach(({ type, data }) => {
        switch (type) {
            case "labs_preparation": {
                const widgetData = {
                    header: data?.header,
                    subHeader: data?.sub_header,
                    descriptionData: {
                        description: data?.instructions,
                        color: null,
                        backgroundColor: data?.background_color,
                    },
                }
                widgetsData.push({ type: "labs_preparation", data: widgetData })
                break
            }
            case "slot_selector": {
                let timeSlotObject = {}
                const selectedDaySlot = getSelectedSlot(data?.days_array, data?.time_slot_data)
                const selectedSlotData = getSelectedTimeSlot(data?.time_slot_data, data?.days_array)
                const daySlotGAData = {
                    ...getGAData(data?.days_array, data?.time_slot_data, meta),
                    selected_slot_details: getSelectedDaySlotGA(data?.days_array, data?.time_slot_data),
                }
                for (let slotId in data.time_slot_data) {
                    const slotData = data.time_slot_data[slotId]
                    timeSlotObject[slotId] = {
                        cta: {
                            label: slotData?.cta?.text,
                            action: slotData?.cta?.action,
                            targetUrl: slotData?.cta?.target_url,
                            isDisabled: slotData?.cta?.is_disabled,
                        },
                        emptySlot: {
                            imageUrl: slotData?.empty_slot_data?.image?.url,
                            imageAltText: slotData?.empty_slot_data?.image?.alt || "No Slot",
                            header: slotData?.empty_slot_data?.heading,
                            description: slotData?.empty_slot_data?.description,
                            cta: slotData?.empty_slot_data?.cta,
                            removeVas: slotData?.empty_slot_data?.remove_premium_vas,
                        },
                        slot: slotData?.slot_data?.map((item) => ({
                            slotId: item?.slot_id,
                            epochSlot: item?.epoch_slot,
                            label: item?.label,
                            subText: item?.sub_text,
                            available: item?.available,
                            isSelected: item?.is_selected,
                            slotIndex: item?.slot_index,
                        })),
                    }
                }
                const widgetData = {
                    daysArray: data.days_array.map((item) => ({
                        title: item?.title,
                        subtext: item?.sub_text,
                        available: item?.available,
                        epochSlot: item?.epoch_slot,
                        isSelected: item?.is_selected,
                        slotHeaderData: {
                            title: item?.slot_header_data?.heading,
                            nudgeText: item?.slot_header_data?.description,
                        },
                        dayIndex: item?.day_index,
                        date: item?.date,
                        slotsCount: item?.slots_count,
                        mixPanelData: data?.time_slot_data?.[item?.epoch_slot]?.analytics_data_mixpanel,
                    })),
                    disclaimer: {
                        imageUrl: data?.disclaimer?.image?.url,
                        altText: data?.disclaimer?.image?.alt || "Alert info",
                        backgroundColor: data?.disclaimer?.background_color,
                        description: data?.disclaimer?.description,
                    },
                    selectedDaySlot: selectedDaySlot,
                    selectedSlotData: { ...selectedSlotData, ...selectedDaySlot },
                    header: data?.header,
                    subHeader: data?.sub_header,
                    timeSlotObject,
                    daySlotGAData,
                }
                widgetsData.push({ type: "slot_selector", data: widgetData })
                break
            }
            default:
        }
    })
    return widgetsData
}

const parseMetaData = (data, meta) => {
    const metaData = {
        hasMoreRecords: meta?.has_more_records,
        pageNumber: meta?.page_number,
        pageSize: meta?.page_size,
        totalRecords: meta?.total_records,
        maxAge: data?.widgets[0]?.data?.max_age,
        minAge: data?.widgets[0]?.data?.min_age,
        maxPatients: data?.widgets[0]?.data?.max_patients,
        cta: {
            action: data?.cta?.action,
            targetUrl: data?.cta?.target_url,
            isPrimaryDisabled: data?.cta?.is_disabled,
            label: data?.cta?.text,
        },
        dialogData: {
            heading: data?.remove_patient_dialog?.header,
            subHeading: data?.remove_patient_dialog?.description,
            primaryCtaLabel: data?.remove_patient_dialog?.confirm_cta?.text,
            secondaryCtaLabel: data?.remove_patient_dialog?.cancel_cta?.text,
        },
    }
    return metaData
}

export const parseWidgetData = (resData, meta) => {
    let widgetsData = []
    resData?.widgets?.forEach(({ type, data }) => {
        switch (type) {
            case "list_patients": {
                widgetsData.push({
                    type: "list_patients",
                    data: {
                        memberList: parsePatientListData(data?.patients),
                        header: null,
                        subHeader: null,
                        ctaLabel: meta?.page_number === 0 ? data?.secondary_action?.text : null,
                        // variant: "small",
                        cta: {
                            action: resData?.cta?.action,
                            targetUrl: resData?.cta?.target_url,
                            isPrimaryDisabled: resData?.cta?.is_disabled,
                            label: resData?.cta?.text,
                        },
                        selectedPatients: data?.selected_patients,
                        maxPatients: data?.max_patients,
                    },
                })
                break
            }
            default:
        }
    })
    return { widgetsData, metaData: parseMetaData(resData, meta) }
}

export const parsePatientObject = (patient, selectedPatients, maxPatients) => {
    const isPatientSelected = selectedPatients <= maxPatients
    const parseData = {
        patientId: patient?.id,
        header: patient?.name,
        subText: patient?.age + ", " + patient?.gender,
        imageUrl: patient?.image?.url,
        value: patient?.name,
        isSelected: isPatientSelected,
        isDisabled: !patient?.is_valid,
        editText: isPatientSelected || !patient?.is_valid ? patient?.primary_cta?.text : null,
        removeText: isPatientSelected || !patient?.is_valid ? patient?.secondary_cta?.text : null,
        dateOfBirth: patient?.date_of_birth,
        gender: patient?.gender,
        age: patient?.age,
        subHeader: patient?.invalid_message,
    }
    return parseData
}

export const parsePatientListData = (data) => {
    const patientListData = []
    data.forEach((patient) => {
        const patientData = {
            patientId: patient?.id,
            header: patient?.name,
            subText: patient?.age + ", " + patient?.gender,
            imageUrl: patient?.image?.url,
            value: patient?.name,
            isSelected: patient?.is_selected,
            isDisabled: !patient?.is_valid,
            dateOfBirth: patient?.date_of_birth,
            gender: patient?.gender,
            age: patient?.age,
            subHeader: patient?.invalid_message,
            editText: patient?.primary_cta?.text,
            removeText: patient?.secondary_cta?.text,
        }
        patientListData.push(patientData)
    })
    return patientListData
}
